'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.publicContents = publicContents;
exports.privateContents = privateContents;
function publicContents(contents) {
    var contentArray = [];
    contents.forEach(function (content) {
        content.shareStatus === 'PUBLIC' ? contentArray.push(content) : null;
    });

    return contentArray.length > 0 ? contentArray : null;
}

function privateContents(contents) {
    var contentArray = [];
    contents.forEach(function (content) {
        content.shareStatus === 'PRIVATE' ? contentArray.push(content) : null;
    });

    return contentArray.length > 0 ? contentArray : null;
}


//////////////////
// WEBPACK FOOTER
// ./~/@getgo/webinar.com-frontend-redux/lib/helpers/contents-helper.js
// module id = 764
// module chunks = 0